<template>
  <div class="container">
    <div class="searchBox">
      <van-search
        v-model="keyword"
        shape="round"
        background="transparent"
        placeholder="产品搜索"
        @search="searchHandle"
      />
    </div>
    <!-- 左边导航 -->
    <div class="classifyBox">
      <div v-for="(item, index) in classifyList" :key="index">
        <div
          class="classifyItem"
          :class="classifyId == item.GoodsCategoryID ? 'cActive' : ''"
          @click.stop="classifyClick(item.GoodsCategoryID, item.CategoryName)"
        >
          <div>{{ item.CategoryName }}</div>
        </div>
      </div>
    </div>

    <!-- 商品 -->
    <div class="goods">
      <div class="goodsTitle">{{ categoryName }}</div>
      <van-list
        v-model="loading"
        :finished="finished"
        :error.sync="error"
        error-text="请求失败，点击重新加载"
        @load="getMobileMemberGoodList"
      >
        <div
          v-for="(item, index) in goodsList"
          :key="index"
          class="comBox"
          @click="toGoodsDetail(item.GoodsId)"
        >
          <img
            class="comPic"
            :src="
              item.Thumbnail
                ? item.Thumbnail
                : '../../images/storeIcon/defaultPhoto.png'
            "
          />
          <div class="name">{{ item.GoodsName }}</div>
        </div>
      </van-list>
    </div>
    <div class="footerSBox">
      <div class="footItem" @click="tabHandle(1)">
        <img
          src="../../../static/images/tabBar/menu1_on.png"
          class="homeIcon"
          v-if="active == 1"
          alt=""
        />
        <img
          src="../../../static/images/tabBar/menu1_off.png"
          class="homeIcon"
          v-else
          alt=""
        />
        <div class="footText">首页</div>
      </div>
      <div class="footItem" @click="tabHandle(2)">
        <img
          src="../../../static/images/tabBar/menu2_on.png"
          class="homeIcon"
          v-if="active == 2"
          alt=""
        />
        <img
          src="../../../static/images/tabBar/menu2_off.png"
          class="homeIcon"
          v-else
          alt=""
        />
        <div class="footText">产品</div>
      </div>
      <div class="footItem" @click="tabHandle(3)">
        <img
          src="../../../static/images/tabBar/menu3_on.png"
          class="homeIcon"
          v-if="active == 3"
          alt=""
        />
        <img
          src="../../../static/images/tabBar/menu3_off.png"
          class="homeIcon"
          v-else
          alt=""
        />
        <div class="footText">公司介绍</div>
      </div>
      <div class="footItem" @click="tabHandle(4)">
        <img
          src="../../../static/images/tabBar/menu4_on.png"
          class="homeIcon"
          v-if="active == 4"
          alt=""
        />
        <img
          src="../../../static/images/tabBar/menu4_off.png"
          class="homeIcon"
          v-else
          alt=""
        />
        <div class="footText">联系</div>
      </div>
    </div>
  </div>
</template>
<script>
import { Search, List } from "vant";
import { categoryList, productList } from "@/api/product";
export default {
  name: "product",
  components: {
    "van-search": Search,
    "van-list": List,
  },
  data() {
    return {
      keyword: "",
      classifyId: 0,
      categoryName: "全部",
      classifyList: [
        {
          GoodsCategoryID: 0,
          CategoryName: "全部",
        },
      ], //分类列表

      goodsList: [], //产品列表
      error: false,
      loading: false,
      finished: false,
      total: 0,
      pageIndex: 1,

      active: 2,
      isCustomCategory: false,
    };
  },
  methods: {
    //tab切换
    tabHandle(type) {
      if (type == 1) {
        this.active = 1;
        this.$router.push({
          path: "/storeShow",
          query: { mid: this.$route.query.mid },
        });
      } else if (type == 2) {
        this.active = 2;
        this.$router.push({
          path: "/product",
          query: { mid: this.$route.query.mid },
        });
      } else if (type == 3) {
        this.active = 3;
        this.$router.push({
          path: "/companyIntro",
          query: { mid: this.$route.query.mid },
        });
      } else if (type == 4) {
        this.active = 4;
        this.$router.push({
          path: "/contact",
          query: { mid: this.$route.query.mid },
        });
      } else {
      }
    },

    // 获取企业自定义类目列表
    getMemberCategoryList() {
      var that = this;
      var data = {
        ParentID: this.$route.query.mid,
      };
      categoryList(data).then((res) => {
        that.classifyList = that.classifyList.concat(res.Data.List);
        that.isCustomCategory = res.Data.IsCustomCategory;
      });
    },

    //确定搜索框
    searchHandle() {
      this.pageIndex = 1;
      this.getMobileMemberGoodList();
    },

    //点击切换
    classifyClick(id, name) {
      this.classifyId = id;
      this.categoryName = name;
      this.pageIndex = 1;
      this.getMobileMemberGoodList();
    },

    //产品详情
    toGoodsDetail(id) {
      this.$router.push({
        path: "/productDetail",
        query: { id: id },
      });
    },

    //获取产品列表
    getMobileMemberGoodList() {
      var that = this;
      var data = {
        CategoryId: that.classifyId,
        Keyword: that.keyword,
        Page: {
          PageSize: 15,
          PageIndex: that.pageIndex,
        },
        IsRecommend: false,
        MemberId: this.$route.query.mid,
        IsCustomCategory: that.isCustomCategory,
      };
      productList(data)
        .then((res) => {
          if (that.pageIndex == 1) {
            this.goodsList = res.Data.List;
          } else {
            this.goodsList = that.goodsList.concat(res.Data.List);
          }
          that.total = res.Data.Total;
          that.pageIndex += 1;
          that.loading = false;
          if (that.goodsList.length >= that.total) {
            that.finished = true;
          }
        })
        .catch((err) => {
          that.loading = false;
          that.error = true;
          that.Common.showMsg(err);
        });
    },
  },
  created() {
    this.getMemberCategoryList();
  },
};
</script>
<style scoped lang="less">
.container {
  min-height: 100vh;
  .searchBox {
    position: fixed;
    width: 100%;
    top: 0px;
    left: 0px;
  }
  /* 左边导航 */
  .classifyBox {
    position: fixed;
    top: 45px;
    left: 0;
    width: 80px;
    height: calc(100vh - 40px - 44px);
    background-color: #efefef;
    padding-top: 10px;
    box-sizing: border-box;
    .classifyItem {
      width: 80px;
      padding: 12px 8px 12px 10px;
      box-sizing: border-box;
      color: #333;
      font-size: 11px;
    }
    .cActive {
      background-color: #fff;
      position: relative;
    }
    .cActive::before {
      content: "";
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 2px;
      height: 100%;
      background: #eb4e4e;
    }
  }
  .goods {
    width: 295px;
    margin-left: 80px;
    margin-top: 40px;
    background: #fff;
    box-sizing: border-box;
    padding: 22px 0px 50px 16px;
    .goodsTitle {
      color: #333;
      font-size: 13px;
      font-weight: bold;
      margin-bottom: 25px;
    }
    .comBox {
      display: flex;
      margin-bottom: 14px;
      .comPic {
        width: 90px;
        height: 90px;
        border-radius: 3px;
      }
      .name {
        width: 150px;
        font-size: 11px;
        color: #333;
        margin-left: 12px;
      }
    }
  }
}
</style>

